module.exports = __webpack_public_path__ + "static/media/14_pouin_a.c82f2f7b.ogg";